<template>
    <admin-layout :sectionTitle="sectionTitle">
        <!--<div class="page-header">
      <div class="row align-items-end">
        <div class="col-sm mb-2 mb-sm-0">
          <h1 class="page-header-title">Agenzia immobiliare</h1>
        </div>

        <div class="col-sm-auto">
          <button type="button" @click="onSubmit" :disabled="form.processing" class="btn btn-primary">Salva</button>
        </div>
      </div>
    </div>-->

        <div class="row">
            <!-- left column -->
            <div class="col-md-8 col-12">
                <!-- company infos -->
                <div class="card mb-4">
                    <div class="card-header">
                        <h3 class="mb-0">Dati società</h3>
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <label>Partner Manager</label>
                            <select
                                v-model="form.parent_id"
                                ref="parentAgency"
                                class="js-select2-custom custom-select"
                                size="1"
                                data-hs-select2-options='{
								"placeholder": "Associa ad un parter manager",
								"searchInputPlaceholder": "cerca partner manager"
					        }'
                            >
                                <option label="empty"></option>
                                <option
                                    v-for="agency in agencies"
                                    :value="agency.id"
                                    :key="agency.id"
                                    v-text="agency.name"
                                ></option>
                            </select>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Ragione sociale</label>
                                    <input
                                        type="text"
                                        v-model="form.company_name"
                                        :class="{
                                            'is-invalid':
                                                form.errors.company_name
                                        }"
                                        class="form-control"
                                    />
                                    <span
                                        class="invalid-feedback d-block"
                                        v-if="form.errors.company_name"
                                        v-text="form.errors.company_name"
                                    ></span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Nome</label>
                                    <input
                                        type="text"
                                        v-model="form.name"
                                        :class="{
                                            'is-invalid': form.errors.name
                                        }"
                                        class="form-control"
                                    />
                                    <span
                                        class="invalid-feedback d-block"
                                        v-if="form.errors.name"
                                        v-text="form.errors.name"
                                    ></span>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-9 col-12">
                                <div class="form-group">
                                    <label>Indirizzo</label>
                                    <input
                                        type="text"
                                        v-model="form.address"
                                        :class="{
                                            'is-invalid': form.errors.address
                                        }"
                                        class="form-control"
                                    />
                                    <span
                                        class="invalid-feedback d-block"
                                        v-if="form.errors.address"
                                        v-text="form.errors.address"
                                    ></span>
                                </div>
                            </div>

                            <div class="col-md-3 col-12">
                                <div class="form-group">
                                    <label>CAP</label>
                                    <input
                                        type="text"
                                        v-model="form.zip"
                                        :class="{
                                            'is-invalid': form.errors.zip
                                        }"
                                        class="form-control"
                                    />
                                    <span
                                        class="invalid-feedback d-block"
                                        v-if="form.errors.zip"
                                        v-text="form.errors.zip"
                                    ></span>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Città</label>
                                    <input
                                        type="text"
                                        v-model="form.municipality"
                                        :class="{
                                            'is-invalid':
                                                form.errors.municipality
                                        }"
                                        class="form-control"
                                    />
                                    <span
                                        class="invalid-feedback d-block"
                                        v-if="form.errors.municipality"
                                        v-text="form.errors.municipality"
                                    ></span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Provincia</label>
                                    <input
                                        type="text"
                                        v-model="form.province"
                                        :class="{
                                            'is-invalid': form.errors.province
                                        }"
                                        class="form-control"
                                    />
                                    <span
                                        class="invalid-feedback d-block"
                                        v-if="form.errors.province"
                                        v-text="form.errors.province"
                                    ></span>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Codice univoco</label>
                                    <input
                                        type="text"
                                        v-model="form.unique_code"
                                        :class="{
                                            'is-invalid':
                                                form.errors.unique_code
                                        }"
                                        class="form-control"
                                    />
                                    <span
                                        class="invalid-feedback d-block"
                                        v-if="form.errors.unique_code"
                                        v-text="form.errors.unique_code"
                                    ></span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>PEC</label>
                                    <input
                                        type="email"
                                        v-model="form.pec"
                                        :class="{
                                            'is-invalid': form.errors.pec
                                        }"
                                        class="form-control"
                                    />
                                    <span
                                        class="invalid-feedback d-block"
                                        v-if="form.errors.pec"
                                        v-text="form.errors.pec"
                                    ></span>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Iban</label>
                            <input
                                type="text"
                                v-model="form.iban"
                                :class="{
                                    'is-invalid': form.errors.iban
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.iban"
                                v-text="form.errors.iban"
                            ></span>
                        </div>
                    </div>
                </div>

                <!-- agency infos -->
                <div class="card mb-4">
                    <div class="card-header">
                        <h3 class="mb-0">Dati agenzia</h3>
                        <label
                            class="toggle-switch toggle-sm"
                            for="agency-toggle"
                        >
                            <span class="mr-2">Franchising</span>
                            <input
                                type="checkbox"
                                @change="
                                    form.agency_franchising =
                                        $event.target.checked
                                "
                                class="js-toggle-switch toggle-switch-input"
                                id="agency-toggle"
                                :checked="form.agency_franchising"
                            />
                            <span class="toggle-switch-label">
                                <span class="toggle-switch-indicator"></span>
                            </span>
                        </label>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Nome agenzia</label>
                                    <input
                                        type="text"
                                        v-model="form.agency_name"
                                        :class="{
                                            'is-invalid':
                                                form.errors.agency_name
                                        }"
                                        class="form-control"
                                    />
                                    <span
                                        class="invalid-feedback d-block"
                                        v-if="form.errors.agency_name"
                                        v-text="form.errors.agency_name"
                                    ></span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Brand</label>
                                    <input
                                        type="text"
                                        v-model="form.agency_brand"
                                        :class="{
                                            'is-invalid':
                                                form.errors.agency_brand
                                        }"
                                        class="form-control"
                                    />
                                    <span
                                        class="invalid-feedback d-block"
                                        v-if="form.errors.agency_brand"
                                        v-text="form.errors.agency_brand"
                                    ></span>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Tipologia sede</label>
                            <input
                                type="text"
                                v-model="form.agency_venue_typology"
                                :class="{
                                    'is-invalid':
                                        form.errors.agency_venue_typology
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.agency_venue_typology"
                                v-text="form.errors.agency_venue_typology"
                            ></span>
                        </div>

                        <div class="row">
                            <div class="col-md-9 col-12">
                                <div class="form-group">
                                    <label>Indirizzo</label>
                                    <input
                                        type="text"
                                        v-model="form.agency_address"
                                        :class="{
                                            'is-invalid':
                                                form.errors.agency_address
                                        }"
                                        class="form-control"
                                    />
                                    <span
                                        class="invalid-feedback d-block"
                                        v-if="form.errors.agency_address"
                                        v-text="form.errors.agency_address"
                                    ></span>
                                </div>
                            </div>

                            <div class="col-md-3 col-12">
                                <div class="form-group">
                                    <label>CAP</label>
                                    <input
                                        type="text"
                                        v-model="form.agency_zip"
                                        :class="{
                                            'is-invalid': form.errors.agency_zip
                                        }"
                                        class="form-control"
                                    />
                                    <span
                                        class="invalid-feedback d-block"
                                        v-if="form.errors.agency_zip"
                                        v-text="form.errors.agency_zip"
                                    ></span>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Città</label>
                                    <input
                                        type="text"
                                        v-model="form.agency_municipality"
                                        :class="{
                                            'is-invalid':
                                                form.errors.agency_municipality
                                        }"
                                        class="form-control"
                                    />
                                    <span
                                        class="invalid-feedback d-block"
                                        v-if="form.errors.agency_municipality"
                                        v-text="form.errors.agency_municipality"
                                    ></span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Provincia</label>
                                    <input
                                        type="text"
                                        v-model="form.agency_province"
                                        :class="{
                                            'is-invalid':
                                                form.errors.agency_province
                                        }"
                                        class="form-control"
                                    />
                                    <span
                                        class="invalid-feedback d-block"
                                        v-if="form.errors.agency_province"
                                        v-text="form.errors.agency_province"
                                    ></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- user -->
                <div class="card" v-if="form.id">
                    <div class="card-header">
                        <h3 class="mb-0">Accesso utente</h3>
                        <label
                            class="toggle-switch toggle-sm mx-2"
                            for="customSwitch"
                        >
                            <input
                                type="checkbox"
                                @change="toggleUser($event)"
                                class="js-toggle-switch toggle-switch-input"
                                id="customSwitch"
                                :checked="form.enable_user"
                            />
                            <span class="toggle-switch-label">
                                <span class="toggle-switch-indicator"></span>
                            </span>
                        </label>
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <label>Nome</label>
                            <input
                                type="text"
                                class="form-control"
                                :class="{
                                    'is-invalid': form.errors['user.name'],
                                    disabled: !form.enable_user
                                }"
                                :disabled="!form.enable_user"
                                v-model="form.user.name"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors['user.name']"
                                v-text="form.errors['user.name']"
                            ></span>
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                class="form-control"
                                :class="{
                                    'is-invalid': form.errors['user.email'],
                                    disabled: !form.enable_user
                                }"
                                :disabled="!form.enable_user"
                                v-model="form.user.email"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors['user.email']"
                                v-text="form.errors['user.email']"
                            ></span>
                        </div>
                        <hr />
                        <div class="form-group">
                            <label>Password</label>
                            <input
                                type="password"
                                class="form-control"
                                :class="{
                                    'is-invalid': form.errors['user.password'],
                                    disabled: !form.enable_user
                                }"
                                :disabled="!form.enable_user"
                                v-model="form.user.password"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors['user.password']"
                                v-text="form.errors['user.password']"
                            ></span>
                        </div>
                        <div class="form-group">
                            <label>Conferma Password</label>
                            <input
                                type="password"
                                class="form-control"
                                :disabled="!form.enable_user"
                                v-model="form.user.password_confirmation"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <!-- right column -->
            <div class="col-md-4 col-12">
                <!-- commercial referent -->
                <div class="card mb-4">
                    <div class="card-header">
                        <h3 class="mb-0">Referente commerciale</h3>
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <label>Nome</label>
                            <input
                                type="text"
                                v-model="form.referent_first_name"
                                :class="{
                                    'is-invalid':
                                        form.errors.referent_first_name
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.referent_first_name"
                                v-text="form.errors.referent_first_name"
                            ></span>
                        </div>

                        <div class="form-group">
                            <label>Cognome</label>
                            <input
                                type="text"
                                v-model="form.referent_last_name"
                                :class="{
                                    'is-invalid': form.errors.referent_last_name
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.referent_last_name"
                                v-text="form.errors.referent_last_name"
                            ></span>
                        </div>

                        <div class="form-group">
                            <label>Data di nascita</label>
                            <input
                                type="date"
                                v-model="form.referent_birth_date"
                                :class="{
                                    'is-invalid':
                                        form.errors.referent_birth_date
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.referent_birth_date"
                                v-text="form.errors.referent_birth_date"
                            ></span>
                        </div>

                        <div class="form-group">
                            <label>Telefono</label>
                            <input
                                type="text"
                                v-model="form.referent_phone"
                                :class="{
                                    'is-invalid': form.errors.referent_phone
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.referent_phone"
                                v-text="form.errors.referent_phone"
                            ></span>
                        </div>

                        <div class="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                v-model="form.referent_email"
                                :class="{
                                    'is-invalid': form.errors.referent_email
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.referent_email"
                                v-text="form.errors.referent_email"
                            ></span>
                        </div>

                        <div class="form-group">
                            <label>Ruolo</label>
                            <input
                                type="text"
                                v-model="form.referent_role"
                                :class="{
                                    'is-invalid': form.errors.referent_role
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.referent_role"
                                v-text="form.errors.referent_role"
                            ></span>
                        </div>
                    </div>
                </div>

                <!-- legal representative -->
                <div class="card mb-4">
                    <div class="card-header">
                        <h3 class="mb-0">Legale rappresentante</h3>
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <label>Nome</label>
                            <input
                                type="text"
                                v-model="form.legal_first_name"
                                :class="{
                                    'is-invalid':
                                        form.errors.legal_first_name
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.legal_first_name"
                                v-text="form.errors.legal_first_name"
                            ></span>
                        </div>

                        <div class="form-group">
                            <label>Cognome</label>
                            <input
                                type="text"
                                v-model="form.legal_last_name"
                                :class="{
                                    'is-invalid': form.errors.legal_last_name
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.legal_last_name"
                                v-text="form.errors.legal_last_name"
                            ></span>
                        </div>

                        <div class="form-group">
                            <label>Data di nascita</label>
                            <input
                                type="date"
                                v-model="form.legal_birth_date"
                                :class="{
                                    'is-invalid':
                                        form.errors.legal_birth_date
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.legal_birth_date"
                                v-text="form.errors.legal_birth_date"
                            ></span>
                        </div>

                        <div class="form-group">
                            <label>Telefono</label>
                            <input
                                type="text"
                                v-model="form.legal_phone"
                                :class="{
                                    'is-invalid': form.errors.legal_phone
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.legal_phone"
                                v-text="form.errors.legal_phone"
                            ></span>
                        </div>

                        <div class="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                v-model="form.legal_email"
                                :class="{
                                    'is-invalid': form.errors.legal_email
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.legal_email"
                                v-text="form.errors.legal_email"
                            ></span>
                        </div>
                    </div>
                </div>

                <!-- others -->
                <div class="card mb-4">
                    <div class="card-body">
                        <div class="form-group">
                            <label>Numero di immobili in vendita</label>
                            <input
                                type="number"
                                v-model="form.selling_properties_count"
                                :class="{
                                    'is-invalid':
                                        form.errors.selling_properties_count
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.selling_properties_count"
                                v-text="form.errors.selling_properties_count"
                            ></span>
                        </div>
                        <div class="form-group">
                            <label>Numero di Agenzie</label>
                            <input
                                type="number"
                                v-model="form.agencies_count"
                                :class="{
                                    'is-invalid':
                                        form.errors.agencies_count
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.agencies_count"
                                v-text="form.errors.agencies_count"
                            ></span>
                        </div>
                        <div class="form-group">
                            <label>Numero di incarichi mensili in esclusiva</label>
                            <input
                                type="number"
                                v-model="form.exclusive_monthly_assignments_count"
                                :class="{
                                    'is-invalid':
                                        form.errors.exclusive_monthly_assignments_count
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.exclusive_monthly_assignments_count"
                                v-text="form.errors.exclusive_monthly_assignments_count"
                            ></span>
                        </div>
                        <div class="form-group">
                            <label>Numero di Agenti Immobiliari</label>
                            <input
                                type="number"
                                v-model="form.agents_count"
                                :class="{
                                    'is-invalid':
                                        form.errors.agents_count
                                }"
                                class="form-control"
                            />
                            <span
                                class="invalid-feedback d-block"
                                v-if="form.errors.agents_count"
                                v-text="form.errors.agents_count"
                            ></span>
                        </div>
                    </div>
                </div>

                <!-- submit -->
                <div class="row">
                    <div class="col d-flex justify-content-end">
                        <button
                            type="button"
                            @click="onSubmit"
                            :disabled="form.processing"
                            class="btn btn-primary"
                        >
                            Salva
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";

export default {
    components: {
        AdminLayout
    },

    props: ["sectionTitle"],

    data() {
        return {
            agencies: this.$page.props.agencies,
            form: this.$inertia.form({
                id: null,

                company_name: null,
                vat_number: null,
                name: null,
                address: null,
                zip: null,
                municipality: null,
                province: null,
                unique_code: null,
                pec: null,
                iban: null,

                agency_name: null,
                agency_franchising: null,
                agency_brand: null,
                agency_venue_typology: null,
                agency_address: null,
                agency_zip: null,
                agency_municipality: null,
                agency_province: null,

                referent_first_name: null,
                referent_last_name: null,
                referent_birth_date: null,
                referent_phone: null,
                referent_email: null,
                referent_role: null,

                legal_first_name: null,
                legal_last_name: null,
                legal_birth_date: null,
                legal_phone: null,
                legal_email: null,

                selling_properties_count: null,
                agencies_count: null,
                exclusive_monthly_assignments_count: null,
                agents_count: null,

                parent_id: null,
                enable_user: false,
                user: {
                    name: null,
                    email: null,
                    password: null,
                    password_confirmation: null
                }
            })
        };
    },

    computed: {
        method() {
            return this.form.id ? "put" : "post";
        }
    },

    mounted() {
        this.initForm();

        var select2 = $.HSCore.components.HSSelect2.init(
            $(this.$refs.parentAgency)
        );
        select2.on("select2:select", e => {
            this.form.parent_id = e.params.data.id;
        });
    },

    methods: {
        toggleUser(ev) {
            this.form.enable_user = ev.target.checked;
        },

        initForm() {
            let init = this.$page.props.agency;

            for (let prop in init) {
                if (this.form.hasOwnProperty(prop)) {
                    this.$set(this.form, prop, init[prop]);
                }
            }
            console.log(init, this.form);
            if (this.form.user) {
                this.$set(
                    this.form,
                    "user",
                    Object.assign(this.form.user, {
                        password: null,
                        password_confirmation: null
                    })
                );
            } else {
                this.form.user = {
                    name: null,
                    email: null,
                    password: null,
                    password_confirmation: null
                };
            }
            this.form.enable_user = this.form.user.hasOwnProperty("id");
        },

        onSubmit() {
            this.form.submit(this.method, this.$page.props.source, {
                onSuccess: () => {
                    this.form.user.password = null;
                    this.form.user.password_confirmation = null;
                }
            });
        }
    }
};
</script>
